export default () => {

    const dropdowns = document.querySelectorAll('.js-load-dropdown');
    for (const dropdown of dropdowns) {
        dropdown.addEventListener('change', (e) => {
            window.location = dropdown.value;
        })
    }

}
